// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"cb159558","551":"fd965809","899":"201331f2"}[chunkId] + ".chunk.css";
};